export default "__VITE_ASSET__bmcEnQ9k__"